import { useState } from "react";
import axios from "axios";
import "../css/Login.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [warning, setWarning] = useState(null);
  const notify = () => toast("Check your inbox !!");

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/customers/forgot-password`,
        data: { email: email },
      });
      console.log(response.data, "Mail sent");
      setWarning("Email sent. Please, check your inbox.");
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  return (
    <main className="container w-75">
      <Link className="text-center d-block mt-4 mb-3" to="/">
        <span className="text-dark brand-name">
          SUPERPOWER
          <i className="bi bi-lightning-fill text-dark"></i>
        </span>
      </Link>
      <div className="card border-0 shadow-lg rounded-3 initiate-session-panel m-0">
        <div className="card-body p-5">
          <form onSubmit={handleSubmit}>
            <h1 className="fs-2">Find your account</h1>
            <h2 className="fs-4">Please enter your email to search for your account</h2>
            <p className="mt-3">
              If its registered, an email will be sent to this account with further instructions.
            </p>
            <div className="mb-2">
              <label htmlFor="email" className="form-label visually-hidden">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                aria-describedby="email"
                value={email}
                placeholder="Email"
                onChange={(ev) => setEmail(ev.target.value)}
              />
            </div>
            {warning && <p className="text-white">{warning}</p>}

            <button className="btn submit-button rounded mt-2" onClick={notify}>
              Submit
            </button>
            <ToastContainer />
          </form>
        </div>
      </div>
    </main>
  );
}

export default ForgotPassword;
